import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';
import type { NotificationItem } from './types';

// 1:1 паттерн mcms-front: state для уведомлений в drawer-формате.
// Сами уведомления приходят из react-query (useNotifications), здесь
// кэшируются для useAppSelector-чтения компонентами.

interface NotificationState {
  notifications: NotificationItem[];
  isNotificationsOpen: boolean;
}

const initialState: NotificationState = {
  notifications: [],
  isNotificationsOpen: false,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications(state, action: PayloadAction<NotificationItem[]>) {
      state.notifications = action.payload;
    },
    setNotificationsOpen(state, action: PayloadAction<boolean>) {
      state.isNotificationsOpen = action.payload;
    },
    toggleNotifications(state) {
      state.isNotificationsOpen = !state.isNotificationsOpen;
    },
    markAllNotificationsAsRead(state) {
      state.notifications = [];
    },
  },
});

export const {
  setNotifications,
  setNotificationsOpen,
  toggleNotifications,
  markAllNotificationsAsRead,
} = notificationSlice.actions;

export const selectNotifications = (state: RootState) => state.notifications.notifications;
export const selectIsNotificationsOpen = (state: RootState) =>
  state.notifications.isNotificationsOpen;
export const selectHasUnreadNotifications = (state: RootState) =>
  state.notifications.notifications.length > 0;

export default notificationSlice.reducer;
